// extracted by mini-css-extract-plugin
export var statItem = "_ju-1";
export var statsRow = "_ju-0";